import { connect } from "react-redux";
import Fallback from "../../Components/GenericComponent/Fallback";

const mapStateToProps = (state) => ({
    QUEUES:state.reducer.QUEUES,
  

});
const mapDispatchToProps = (dispatch) => ({
  
});
 
export default connect(mapStateToProps, mapDispatchToProps)(Fallback);